import {
  createWishlistItem,
  fetchMyWishlist,
  fetchUserWishlist,
  updateWishlistItem,
  deleteWishlistItem,
  reserveWishlistItem,
  unreserveWishlistItem,
} from './wishlist.api';

const stateData = {
  myWishlist: [],
  userWishlist: [],
  currentWishlistUser: null,
};

const mutations = {
  setMyWishlist(state, { items }) {
    state.myWishlist = items;
  },
  setUserWishlist(state, { items, user }) {
    state.userWishlist = items;
    state.currentWishlistUser = user;
  },
  addWishlistItem(state, { item }) {
    state.myWishlist.push(item);
  },
  updateWishlistItem(state, { item }) {
    const index = state.myWishlist.findIndex(i => i.id === item.id);
    if (index !== -1) {
      state.myWishlist[index] = item;
    }
  },
  deleteWishlistItem(state, { id }) {
    state.myWishlist = state.myWishlist.filter(i => i.id !== id);
  },
  updateUserWishlistItem(state, { item }) {
    const index = state.userWishlist.findIndex(i => i.id === item.id);
    if (index !== -1) {
      state.userWishlist[index] = item;
    }
  },
};

const actions = {
  async fetchMyWishlist({ commit }) {
    try {
      const { items } = await fetchMyWishlist();
      commit('setMyWishlist', { items });
    } catch (error) {
      console.error(error);
      throw new Error('Impossible de récupérer votre wishlist');
    }
  },
  async fetchUserWishlist({ commit }, { userId }) {
    try {
      const { items, user } = await fetchUserWishlist({ userId });
      commit('setUserWishlist', { items, user });
    } catch (error) {
      console.error(error);
      throw new Error('Impossible de récupérer la wishlist');
    }
  },
  async createWishlistItem({ commit }, { name, url, description }) {
    try {
      const { item } = await createWishlistItem({ name, url, description });
      commit('addWishlistItem', { item });
    } catch (error) {
      console.error(error);
      throw new Error('Impossible de créer le cadeau');
    }
  },
  async updateWishlistItem({ commit }, { id, name, url, description }) {
    try {
      const { item } = await updateWishlistItem({ id, name, url, description });
      commit('updateWishlistItem', { item });
    } catch (error) {
      console.error(error);
      throw new Error('Impossible de mettre à jour le cadeau');
    }
  },
  async deleteWishlistItem({ commit }, { id }) {
    try {
      await deleteWishlistItem({ id });
      commit('deleteWishlistItem', { id });
    } catch (error) {
      console.error(error);
      throw new Error('Impossible de supprimer le cadeau');
    }
  },
  async reserveWishlistItem({ commit }, { id }) {
    try {
      const { item } = await reserveWishlistItem({ id });
      commit('updateUserWishlistItem', { item });
    } catch (error) {
      console.error(error);
      throw new Error('Impossible de réserver le cadeau');
    }
  },
  async unreserveWishlistItem({ commit }, { id }) {
    try {
      const { item } = await unreserveWishlistItem({ id });
      commit('updateUserWishlistItem', { item });
    } catch (error) {
      console.error(error);
      throw new Error('Impossible de libérer le cadeau');
    }
  },
};

export default {
  namespaced: true,
  state: { ...stateData },
  mutations,
  actions,
};
